module.exports = __webpack_public_path__ + "img/spxflow-logo-2C.23d552ee.png";